import {Component, Input, OnInit} from '@angular/core';
import {NgIf, NgStyle} from "@angular/common";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  animations: [
    trigger('slideUpDown', [
      state('collapsed', style({
        height: '0',
        paddingTop: '0',
        paddingBottom: '0',
        opacity: '0'
      })),
      state('expanded', style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        opacity: '1'
      })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out'))
    ])
  ],
  imports: [
    NgStyle,
    NgIf
  ],
  selector: 'app-section-card',
  standalone: true,
  styleUrl: './section-card.component.scss',
  templateUrl: './section-card.component.html'
})
export class SectionCardComponent  {
  @Input() title: string = '';
  @Input() enableToggle: boolean = true;

  isExpanded = true;

  toggleSection() {
    if (this.enableToggle) {
      this.isExpanded = !this.isExpanded;
    }
  }
}
